import type HotelPackage from '@itinerary/hotel/HotelPackage';

export function useData() {
    const hotelModule = useHotelModule();
    const packageSelectStore = usePackageSelectStore();
    const { selectedPackages } = classToRefs(packageSelectStore);
    const hotelPackage = computed(
        () =>
            (selectedPackages.value[0] as HotelPackage | undefined) ||
            hotelModule.ssrHotelPackage ||
            hotelModule.emptyPackage
    );
    const loadingClass = computed(() => ({
        'loading-skeleton': hotelModule.isLoadingHotelInfo,
    }));
    const title = computed(() => hotelPackage.value?.title || '');
    return {
        hotelPackage,
        loadingClass,
        title,
    };
}
